import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
import _get from "lodash/get";
import _cloneDeep from "lodash/cloneDeep";

var _templateObject, _templateObject2, _templateObject3;

import "core-js/modules/es6.array.map.js";
import { gql } from '@nerdwallet/apollo';
var ABQueryFields = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  fragment ABQueryFields on Experiment {\n    experimentName\n    assignedVariant\n    assignedVariantName\n    isForcedVariant\n    experimentId\n    rampNum\n    usesEEE\n    variants {\n      variantId\n      variantName\n      customData\n    }\n  }\n"]))); // SELECTIONS_PATH corresponds to [0] the Field (abExperiments) and [1] the Fragment Definition (ABQueryFields)

var SELECTIONS_PATH = 'definitions[0].selectionSet.selections';
var AB_EXPERIMENTS_SELECTION_PATH = 'definitions[0].selectionSet.selections[0]'; // Index 0 (see above description, and below query)

var getABQuery = function getABQuery(testName) {
  return gql(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n{\n  ", ": abExperiments(testNames: [\"", "\"]) {\n    ...ABQueryFields\n  }\n}\n", "\n"])), testName, testName, ABQueryFields);
};
/**
 * This is an implementation-specific (query above) utility function for combining like (queries that are composed the same way) queries
 * Namely, the query above
 */


var combineQueries = function combineQueries(queryDocuments) {
  if (!(queryDocuments !== null && queryDocuments !== void 0 && queryDocuments.length)) {
    return null;
  }

  if (queryDocuments.length === 1) {
    return queryDocuments[0];
  }

  var combinedQuery = _cloneDeep(queryDocuments.pop());

  var injectionPoint = _get(combinedQuery, SELECTIONS_PATH);

  queryDocuments.forEach(function (documentToCombine) {
    var extractedSelection = _get(documentToCombine, AB_EXPERIMENTS_SELECTION_PATH);

    injectionPoint.push(extractedSelection);
  });
  return combinedQuery;
};
/**
 * Composes a graphql query that is composed of individual query fields (one for each test)
 * for the purpose of loading the Apollo-client cache with the cached query results required
 * by the invocation of hooks and usage of components provided in this library
 *
 * @param testNames
 * @returns composed query
 *
 * Usage:
 * apolloClient.query({
 *   query: getABTestsQuery(['test-a', 'test-b'])
 * })
 */


export var getABTestsQuery = function getABTestsQuery(testNames) {
  var individualQueries = testNames.map(function (testName) {
    return getABQuery(testName);
  });
  return combineQueries(individualQueries);
}; // Exported for testing

export var ABQuery = gql(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  query ab($testName: String) {\n    abExperiments(testNames: [$testName]) {\n      ...ABQueryFields\n    }\n  }\n  ", "\n"])), ABQueryFields);